import { render, staticRenderFns } from "./contentCardBaseF.vue?vue&type=template&id=480019e3&scoped=true"
import script from "./contentCardBaseF.vue?vue&type=script&lang=js"
export * from "./contentCardBaseF.vue?vue&type=script&lang=js"
import style0 from "./contentCardBaseF.vue?vue&type=style&index=0&id=480019e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480019e3",
  null
  
)

export default component.exports